import InstructionCards from "./InstructionCards";

const Instructions = () => {
  return (
    <InstructionCards/>
  );
};

export default Instructions;
